module.exports = __webpack_public_path__ + "static/media/retirement-object-4-0-2.6fa8d49e.svg";